import axios from 'axios';

import { APP_PARTNER_ID_HEADER } from '../../../configs/services/services.config';
import { getPartnerId } from '../../../utils/partner/partner.util';

import { URL } from './auth.config';

import type { IPostLogInParams, IPostLogInResponse, IPostRefreshTokenParams } from './auth.type';

/**
 * Returns Bearer Token used to validate an user idendity.
 * Token should be passed in the header of every request as Authorization: Bearer {token}.
 *
 * {@link https://dev-openapi.safeandtrust.eu/#tag/auth/operation/createSignallerToken Safe&Trust API Docs}
 */
export const postLogIn = async (params: IPostLogInParams): Promise<IPostLogInResponse> => {
  const { data } = await axios.post<IPostLogInResponse>(URL.postLogIn, params, {
    params: {
      grantType: 'authGrantCreds',
    },
    headers: { [APP_PARTNER_ID_HEADER]: getPartnerId() },
  });

  return data;
};

/**
 * Used to revoke a token from the user.
 *
 * {@link https://dev-openapi.safeandtrust.eu/#tag/auth/operation/createSignallerToken Safe&Trust API Docs}
 */
export const postRefreshToken = async (
  params: IPostRefreshTokenParams,
): Promise<IPostLogInResponse> => {
  const { data } = await axios.post<IPostLogInResponse>(URL.postLogIn, params, {
    params: {
      grantType: 'authGrantRefresh',
    },
  });

  return data;
};

/**
 * Logout user by invalidating his tokens in the following order:
 *
 * {@link https://dev-openapi.safeandtrust.eu/#tag/auth/operation/logout API Docs}
 */
export const deleteToken = async (token: string, refreshToken: string): Promise<void> => {
  await axios.delete(URL.deleteToken.replace('{token}', token));
  await axios.delete(URL.deleteToken.replace('{token}', refreshToken));
};
